import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import CheckIcon from '@atlaskit/icon/glyph/check';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';

import { COLUMN_HEADER_TEST_ID_PREFIX } from '../../../../../common/constants';
import messages from './messages';

type Props = {
	icon: ReactNode;
	name: string;
};

export const SelectedField = ({ icon, name }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper data-testId={`${COLUMN_HEADER_TEST_ID_PREFIX}.selected-field.wrapper`}>
			<SelectedCustomFieldContent>
				{icon}
				<span>{name}</span>
			</SelectedCustomFieldContent>
			<SelectedIconWrapper>
				<CheckIcon label="" testId={`${COLUMN_HEADER_TEST_ID_PREFIX}.selected-field.check-icon`} />
				<span>{formatMessage(messages.selected)}</span>
			</SelectedIconWrapper>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SelectedIconWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.accent.blue', colors.B400),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: `${token('space.100', '8px')} ${token('space.200', '16px')} ${token(
		'space.100',
		'8px',
	)} ${token('space.100', '8px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.neutral', colors.N20),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SelectedCustomFieldContent = styled.div({
	display: 'flex',
	alignItems: 'center',
	cursor: 'default',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> span': {
		marginLeft: token('space.100', '8px'),
	},
});
